import uiRouter from '@uirouter/angularjs';

import angular from 'angular';

export const SettingsIntegrationView = angular
  .module('acme.view.application.settings.integration', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.settings.integration.controllers',
    'acme.view.application.settings.integration.sync',
    'acme.view.application.settings.integration.logs',
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const settingsIntegration = {
      name: 'application.settings.integration',
      url: '/integration',
      views: {
        'subview-main': {
          controller: 'SettingsIntegrationController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settings/integration/integration.tpl.html',
        },
      },
      data: {
        pageTitle: 'Salesforce Integration',
        enablePreferences: true,
      },
    };

    $stateProvider.state(settingsIntegration);
  }).name;
